import { useJsApiLoader } from '@react-google-maps/api';
import { useMemo } from 'react';

// Workaround for performance warning issue
const libraries: ('places' | 'drawing' | 'geometry' | 'localContext' | 'visualization')[] = [
  'places',
];

export const useGeocoder = (): google.maps.Geocoder | undefined => {
  const { isLoaded, loadError: hasError } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? '',
    libraries,
  });

  return useMemo(
    () => (isLoaded && !hasError ? new google.maps.Geocoder() : undefined),
    [isLoaded, hasError]
  );
};
